module.exports = __webpack_public_path__ + "static/media/logo.b36e4e9d.svg";